import React, { useState, useEffect } from 'react';
import { Card, Button, Typography, Space, Alert, Spin } from 'antd';
import { useAuthStore } from '../../stores/authStore';
import axios from 'axios';

const { Text, Paragraph } = Typography;

/**
 * API测试页面 - 用于调试任务下拉框问题
 */
const ApiTest = () => {
  const [testResults, setTestResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const { user, token, isAuthenticated } = useAuthStore();

  // 添加测试结果
  const addResult = (test, success, data, error = null) => {
    setTestResults(prev => [...prev, {
      test,
      success,
      data,
      error,
      timestamp: new Date().toLocaleTimeString()
    }]);
  };

  // 测试认证状态
  const testAuthStatus = () => {
    addResult('认证状态检查', true, {
      isAuthenticated,
      hasUser: !!user,
      hasToken: !!token,
      userName: user?.realName,
      userRole: user?.role,
      axiosHeaders: axios.defaults.headers.common
    });
  };

  // 测试任务API
  const testTasksApi = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/tasks/my', {
        params: { status: 'pending,in_progress' }
      });
      
      addResult('任务API调用', true, {
        status: response.status,
        success: response.data.success,
        taskCount: response.data.data?.tasksByProject?.length || 0,
        totalTasks: response.data.data?.tasksByProject?.reduce((acc, group) => acc + group.tasks.length, 0) || 0,
        data: response.data
      });
    } catch (error) {
      addResult('任务API调用', false, null, {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
    } finally {
      setLoading(false);
    }
  };

  // 清除测试结果
  const clearResults = () => {
    setTestResults([]);
  };

  // 页面加载时自动测试认证状态
  useEffect(() => {
    testAuthStatus();
  }, []);

  return (
    <div style={{ padding: '24px' }}>
      <Card title="API调试测试页面" style={{ marginBottom: 24 }}>
        <Paragraph>
          这个页面用于调试工作日志页面中任务下拉框为空的问题。
        </Paragraph>
        
        <Space wrap>
          <Button onClick={testAuthStatus}>测试认证状态</Button>
          <Button onClick={testTasksApi} loading={loading} type="primary">
            测试任务API
          </Button>
          <Button onClick={clearResults}>清除结果</Button>
        </Space>
      </Card>

      {testResults.map((result, index) => (
        <Card 
          key={index} 
          title={`${result.timestamp} - ${result.test}`}
          style={{ marginBottom: 16 }}
          size="small"
        >
          {result.success ? (
            <Alert 
              type="success" 
              message="测试成功" 
              description={
                <pre style={{ 
                  background: '#f6ffed', 
                  padding: 8, 
                  borderRadius: 4,
                  fontSize: '12px',
                  maxHeight: '300px',
                  overflow: 'auto'
                }}>
                  {JSON.stringify(result.data, null, 2)}
                </pre>
              }
            />
          ) : (
            <Alert 
              type="error" 
              message="测试失败" 
              description={
                <pre style={{ 
                  background: '#fff2f0', 
                  padding: 8, 
                  borderRadius: 4,
                  fontSize: '12px',
                  maxHeight: '300px',
                  overflow: 'auto'
                }}>
                  {JSON.stringify(result.error, null, 2)}
                </pre>
              }
            />
          )}
        </Card>
      ))}

      {testResults.length === 0 && (
        <Card>
          <Text type="secondary">点击上方按钮开始测试</Text>
        </Card>
      )}
    </div>
  );
};

export default ApiTest;